// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-agents-container {
  padding-top: 80px;
}
.select-agents-container .header {
  flex-direction: column;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  gap: 8px;
}
.select-agents-container .header > p {
  margin: 0;
}
.select-agents-container .header .back-button {
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  color: #2a2a2a;
  position: absolute;
  left: 0;
  transition: 0.2s ease-in-out;
}
.select-agents-container .header .back-button:hover {
  color: var(--primary-color-1);
}
.select-agents-container .agents {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 100%;
}
.select-agents-container .agents ::-webkit-scrollbar {
  width: 5px;
  opacity: 0;
}
.select-agents-container .agents:hover {
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.select-agents-container .agents:hover ::-webkit-scrollbar {
  opacity: 1;
}
.select-agents-container .agents:hover ::-webkit-scrollbar-track {
  border-radius: 10px;
}
.select-agents-container .agents:hover ::-webkit-scrollbar-thumb {
  background: #b4b4b4;
  border-radius: 10px;
}
.select-agents-container .agents:hover ::-webkit-scrollbar-thumb:hover {
  background: #b4b4b4;
}
.select-agents-container .agents .contents {
  min-height: calc(100vh - 190px);
  height: 100%;
  padding-top: 40px;
}
.select-agents-container .agents .contents p.no-result {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  color: var(--secondary-color-5);
  animation: fadeIn 1s;
}
.select-agents-container .agents .contents .loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.863);
  z-index: 2;
  display: flex;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingRequest/modules/SelectAgent/selectAgent.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AACI;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AACR;AACQ;EACI,SAAA;AACZ;AAEQ;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,4BAAA;AAAZ;AAEY;EACI,6BAAA;AAAhB;AAII;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAFR;AAIQ;EACI,UAAA;EACA,UAAA;AAFZ;AAKQ;EAKI,UAAA;EAKA,WAAA;EAMA,oBAAA;AAhBZ;AACY;EACI,UAAA;AAChB;AAGY;EACI,mBAAA;AADhB;AAKY;EACI,mBAAA;EACA,mBAAA;AAHhB;AAOY;EACI,mBAAA;AALhB;AASQ;EACI,+BAAA;EACA,YAAA;EACA,iBAAA;AAPZ;AASY;EACI,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,oBAAA;AAPhB;AAUY;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,4CAAA;EACA,UAAA;EACA,aAAA;AARhB;AAaI;EACI;IACI,UAAA;EAXV;EAcM;IACI,UAAA;EAZV;AACF","sourcesContent":[".select-agents-container {\r\n    padding-top: 80px;\r\n\r\n    .header {\r\n        flex-direction: column;\r\n        display: flex;\r\n        align-items: center;\r\n        position: relative;\r\n        width: 100%;\r\n        gap: 8px;\r\n\r\n        >p {\r\n            margin: 0;\r\n        }\r\n\r\n        .back-button {\r\n            cursor: pointer;\r\n            font-size: 16px;\r\n            font-weight: 700;\r\n            color: #2a2a2a;\r\n            position: absolute;\r\n            left: 0;\r\n            transition: .2s ease-in-out;\r\n\r\n            &:hover {\r\n                color: var(--primary-color-1);\r\n            }\r\n        }\r\n    }\r\n    .agents {\r\n        width: 100%;\r\n        overflow: hidden;\r\n        position: relative;\r\n        height: 100%;\r\n\r\n        ::-webkit-scrollbar {\r\n            width: 5px;\r\n            opacity: 0;\r\n        }\r\n\r\n        &:hover {\r\n            ::-webkit-scrollbar {\r\n                opacity: 1;\r\n            }\r\n\r\n            /* Track */\r\n            ::-webkit-scrollbar-track {\r\n                border-radius: 10px;\r\n            }\r\n\r\n            /* Handle */\r\n            ::-webkit-scrollbar-thumb {\r\n                background: #b4b4b4;\r\n                border-radius: 10px;\r\n            }\r\n\r\n            /* Handle on hover */\r\n            ::-webkit-scrollbar-thumb:hover {\r\n                background: #b4b4b4;\r\n            }\r\n        }\r\n\r\n        .contents {\r\n            min-height: calc(100vh - 190px);\r\n            height: 100%;\r\n            padding-top: 40px;\r\n\r\n            p.no-result {\r\n                font-family: 'Proxima Nova', sans-serif;\r\n                font-weight: 700;\r\n                font-size: 18px;\r\n                text-align: center;\r\n                color: var(--secondary-color-5);\r\n                animation: fadeIn 1s;\r\n            }\r\n\r\n            .loader {\r\n                position: absolute;\r\n                left: 0;\r\n                right: 0;\r\n                top: 0;\r\n                bottom: 0;\r\n                background-color: rgba(255, 255, 255, 0.863);\r\n                z-index: 2;\r\n                display: flex;\r\n            }\r\n        }\r\n    }\r\n\r\n    @keyframes fadeIn {\r\n        0% {\r\n            opacity: 0;\r\n        }\r\n\r\n        100% {\r\n            opacity: 1;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
